import { SET_VAULTING_REQUESTS_CURRENT_PAGE } from '../actions/actionTypes';

const initialState = {
  currentPage: 0,
};

const vaultingRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VAULTING_REQUESTS_CURRENT_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default vaultingRequestsReducer;
